// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.UiaQJ_dNNxl9BsffIoh7 {
    padding: 20px 270px;
    background-color: #F5F5F5;
    min-height: 100vh;
    display: flex;
    flex-direction: column;
}

.NuDskgJakrFeuBxWFl1u{
    margin-top: -5px;
    font-size: 20px;
}

.Q5gY7neEzyRsfnT5XCyL{
    display: flex;
    justify-content: flex-start;
    gap: 10px;
    align-items: center;
}

.LlF05glzLtTeQckurP0F {
    padding-top: 10px;
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.EyQOKlNvJeSBGkB50zcg{
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
}

.lV0qle81DRIQGbDutCtj{
    height: 65vh;
    display: flex;
    justify-content: center;
    align-items: center;
    font-weight: bold;
    font-size: 20px;
}

.KIWD0Vdr0rO_2HIQfycQ {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 20px;
    width: 100%;
    margin-top: 15px;
}

.yOxydcKAMjCxdKVFcj76 {
    background-color: white;
    height: 40px;
    border-radius: 12px;
}

.H6X3NbXsmCQkssTnv5R2 {
    border-radius: 10px;
    margin-top: 20px;
    display: flex;
    gap: 15px;
    flex-direction: column;
    width: 100%;
}

.m8DPZopupTFasYxhcKlg {
    position: absolute;
    top: 50%;
    left: 50%;
}

.FFJFMuUfTUwgw0xyRVon {
    background-color: white;
    padding: 0 15px;
    border-radius: 10px;
}

.O7GArUonjTFMB_mOILB2 {
    display: flex;
    gap: 10px;
    align-items: center;
}

.rISvDdxl7tmpMxe1Opy2 {
    display: flex;
    gap: 15px;
}

.yKBV1cjiFoosyBuFsS4x, .M9t0dcw_VReNdRwTDifC {
    font-size: 12px;
    padding: 4px 10px;
    background-color: #f0f0f0;
    border-radius: 20px;
    display: flex;
    gap: 5px;
    border: none;
    color: #555;
    cursor: pointer;
    height: 20px;
    align-items: center;
}

.u14TWvPTppU7bKR_fF5a, .VaUJ7_YiFd_Z2kDrYy2Q {
    display: flex;
    padding: 7px 5px;
    font-size: 10px;
    align-items: center;
    justify-content: center;
    width: 60px;
    background-color: #004BA0;
    height: 10px;
    border: none;
    color: white;
    border-radius: 20px;
    cursor: pointer;
}

.hxL6KDRo82mlFQsoo9k8 {
    cursor: pointer;
    display: flex;
    flex-direction: column;
    padding: 10px 0;
}

.AFPTaQDqu6skGD3xN4zK {
    font-weight: bold;
    color: #1a73e8;
}

.klOgCXUEWELsYkkGJ0S6 {
    font-size: 14px;
    color: #333;
    margin-top: 5px;
}
`, "",{"version":3,"sources":["webpack://./src/home/css/community-my-questions-detailed.module.css"],"names":[],"mappings":"AAAA;IACI,mBAAmB;IACnB,yBAAyB;IACzB,iBAAiB;IACjB,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,2BAA2B;IAC3B,SAAS;IACT,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;IACjB,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,gCAAgC;AACpC;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,iBAAiB;IACjB,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,SAAS;IACT,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,uBAAuB;IACvB,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,gBAAgB;IAChB,aAAa;IACb,SAAS;IACT,sBAAsB;IACtB,WAAW;AACf;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,SAAS;AACb;;AAEA;IACI,uBAAuB;IACvB,eAAe;IACf,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,SAAS;IACT,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,SAAS;AACb;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,yBAAyB;IACzB,mBAAmB;IACnB,aAAa;IACb,QAAQ;IACR,YAAY;IACZ,WAAW;IACX,eAAe;IACf,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,gBAAgB;IAChB,eAAe;IACf,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;IACX,yBAAyB;IACzB,YAAY;IACZ,YAAY;IACZ,YAAY;IACZ,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,aAAa;IACb,sBAAsB;IACtB,eAAe;AACnB;;AAEA;IACI,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,WAAW;IACX,eAAe;AACnB","sourcesContent":[".questionDetailedMain {\n    padding: 20px 270px;\n    background-color: #F5F5F5;\n    min-height: 100vh;\n    display: flex;\n    flex-direction: column;\n}\n\n.myQues{\n    margin-top: -5px;\n    font-size: 20px;\n}\n\n.myQuesContainer{\n    display: flex;\n    justify-content: flex-start;\n    gap: 10px;\n    align-items: center;\n}\n\n.head {\n    padding-top: 10px;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n}\n\n.loader{\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n}\n\n.noQuestions{\n    height: 65vh;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    font-weight: bold;\n    font-size: 20px;\n}\n\n.searchContainer {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    gap: 20px;\n    width: 100%;\n    margin-top: 15px;\n}\n\n.searchWrapper {\n    background-color: white;\n    height: 40px;\n    border-radius: 12px;\n}\n\n.questionsContainer {\n    border-radius: 10px;\n    margin-top: 20px;\n    display: flex;\n    gap: 15px;\n    flex-direction: column;\n    width: 100%;\n}\n\n.loadQuestions {\n    position: absolute;\n    top: 50%;\n    left: 50%;\n}\n\n.questionItem {\n    background-color: white;\n    padding: 0 15px;\n    border-radius: 10px;\n}\n\n.myQuestionsDetailedLeft {\n    display: flex;\n    gap: 10px;\n    align-items: center;\n}\n\n.myQuestionsDetailedRight {\n    display: flex;\n    gap: 15px;\n}\n\n.answerCount, .copyLink {\n    font-size: 12px;\n    padding: 4px 10px;\n    background-color: #f0f0f0;\n    border-radius: 20px;\n    display: flex;\n    gap: 5px;\n    border: none;\n    color: #555;\n    cursor: pointer;\n    height: 20px;\n    align-items: center;\n}\n\n.editButton, .deleteButton {\n    display: flex;\n    padding: 7px 5px;\n    font-size: 10px;\n    align-items: center;\n    justify-content: center;\n    width: 60px;\n    background-color: #004BA0;\n    height: 10px;\n    border: none;\n    color: white;\n    border-radius: 20px;\n    cursor: pointer;\n}\n\n.questionBody {\n    cursor: pointer;\n    display: flex;\n    flex-direction: column;\n    padding: 10px 0;\n}\n\n.questionTitle {\n    font-weight: bold;\n    color: #1a73e8;\n}\n\n.description {\n    font-size: 14px;\n    color: #333;\n    margin-top: 5px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"questionDetailedMain": `UiaQJ_dNNxl9BsffIoh7`,
	"myQues": `NuDskgJakrFeuBxWFl1u`,
	"myQuesContainer": `Q5gY7neEzyRsfnT5XCyL`,
	"head": `LlF05glzLtTeQckurP0F`,
	"loader": `EyQOKlNvJeSBGkB50zcg`,
	"noQuestions": `lV0qle81DRIQGbDutCtj`,
	"searchContainer": `KIWD0Vdr0rO_2HIQfycQ`,
	"searchWrapper": `yOxydcKAMjCxdKVFcj76`,
	"questionsContainer": `H6X3NbXsmCQkssTnv5R2`,
	"loadQuestions": `m8DPZopupTFasYxhcKlg`,
	"questionItem": `FFJFMuUfTUwgw0xyRVon`,
	"myQuestionsDetailedLeft": `O7GArUonjTFMB_mOILB2`,
	"myQuestionsDetailedRight": `rISvDdxl7tmpMxe1Opy2`,
	"answerCount": `yKBV1cjiFoosyBuFsS4x`,
	"copyLink": `M9t0dcw_VReNdRwTDifC`,
	"editButton": `u14TWvPTppU7bKR_fF5a`,
	"deleteButton": `VaUJ7_YiFd_Z2kDrYy2Q`,
	"questionBody": `hxL6KDRo82mlFQsoo9k8`,
	"questionTitle": `AFPTaQDqu6skGD3xN4zK`,
	"description": `klOgCXUEWELsYkkGJ0S6`
};
export default ___CSS_LOADER_EXPORT___;
